import React, { memo } from 'react';

const AgentInfoInner = () => (
    <svg viewBox="0 0 18 20">
        <path d="M1.81538 0C1.2631 0 0.815384 0.447715 0.815384 1V19C0.815384 19.5523 1.2631 20 1.81538 20H16.7077C17.26 20 17.7077 19.5523 17.7077 19V1C17.7077 0.447715 17.26 0 16.7077 0H1.81538ZM2.69231 2H15.8308V18H2.69231V2ZM4.56923 5V7H13.9538V5H4.56923ZM4.56923 9V11H6.44615V9H4.56923ZM8.32308 9V11H13.9538V9H8.32308ZM4.56923 13V15H6.44615V13H4.56923ZM8.32308 13V15H13.9538V13H8.32308Z" />
    </svg>
);

export const AgentInfo = memo(AgentInfoInner);
